export default "__VITE_ASSET__JveseYL4__"